import React from 'react';
import ArrowIcon from '../../../images/svg/arrow.svg';
import { useSliderContext, useSliderInstanceContext } from './index';
import { colors } from '../colors';
import { breakpoints } from '../tokens';

export const SliderLeftButton = (): JSX.Element => {
    const { paginate, page } = useSliderContext();
    const { infinite } = useSliderInstanceContext();

    return (
        <button
            type="button"
            aria-label="Jump to previous slide"
            onClick={(): void => paginate(-1)}
            disabled={!infinite && page <= 0}
        >
            <ArrowIcon
                css={{
                    maxWidth: '32px',
                    fill: colors.grey300,
                    [breakpoints.tb]: {
                        maxWidth: '16px',
                    },
                }}
            />
        </button>
    );
};

export const SliderRightButton = (): JSX.Element => {
    const { paginate } = useSliderContext();
    return (
        <button
            type="button"
            aria-label="Jump to next slide"
            onClick={(): void => paginate(1)}
        >
            <ArrowIcon
                css={{
                    maxWidth: '32px',
                    fill: colors.grey300,
                    transform: 'rotate(180deg)',
                    [breakpoints.tb]: {
                        maxWidth: '16px',
                    },
                }}
            />
        </button>
    );
};
